import type { DYAdminConfig } from "../app.config.value"

export function useDYAdminConfig() {
  const config = useAppConfig() as unknown as DYAdminConfig
  return {
    ...config
  }
}